import styles from './Button.module.css'

interface ButtonProps {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  variant?: 'primary' | 'ghost' | 'blue'
  size?: 'default' | 'sm'
  type?: 'button' | 'submit'
  className?: string
}

export default function Button({
  children,
  onClick,
  disabled,
  variant = 'primary',
  size = 'default',
  type = 'button',
  className,
}: ButtonProps) {
  return (
    <button
      type={type}
      className={[
        styles.btn,
        styles[variant],
        size === 'sm' && styles.sm,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
